/**
 * Refresh caches that are filtered by membership tier.
 */
import type { QueryClient } from '@tanstack/react-query';
import { queryClient as defaultQueryClient, queryKeys } from './queryClient';

export async function invalidateMembershipQueries(
  userId?: string | null,
  client: QueryClient = defaultQueryClient,
): Promise<void> {
  const id = userId ?? undefined;
  await Promise.all([
    client.invalidateQueries({ queryKey: queryKeys.announcements(id) }),
    client.invalidateQueries({ queryKey: queryKeys.subscriptionState(id) }),
    client.invalidateQueries({ queryKey: ['hubCtas'] }),
    client.invalidateQueries({ queryKey: ['subscription-interval'] }),
    client.invalidateQueries({ queryKey: ['courses'] }),
    client.invalidateQueries({ queryKey: ['purchasedCourses'] }),
  ]);
}
